module.exports = __webpack_public_path__ + "static/media/ChevronRight.600ffa1b.svg";